export default __webpack_public_path__ + "static/media/painel_pesquisa.1941e243.svg";